<template>
    <div class="card card-custom">
        <div class="card-body form-text text-center">
            <h4 class="line-height-lg">{{ text }}</h4>
            <br>
            <h4>{{ __('locked.activate') }}</h4>
            <a target="_blank" :href="`${$page.props.frontend_url}#pricing`"><h4>{{ __('locked.pricing') }}</h4></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeatureLocked',
    props: {
        text: String,
    }
};
</script>
